// eslint-disable-next-line
import { query_string, isMac } from '@vkplay/shared';

export const availableLanguagesFull = {
  en: 'en_US',
  de: 'de_DE',
  fr: 'fr_FR',
  es: 'es_ES',
  pl: 'pl_PL',
  ru: 'ru_RU',
  tr: 'tr_TR',
  ar: 'ar_AA',
};

export const buildDownloadUrl = () => {
  // eslint-disable-next-line
  const domain = 'https://static.gc.vkplay.ru';
  const gcDownloadPathname = isMac ? '/gcmac/distrib/GameCenterShowcase' : '/VKPlayLoader';
  const urlBase = `${domain}${gcDownloadPathname}`;
  const ext = isMac ? 'dmg' : 'exe';

  return `${urlBase}.${ext}`;
};

export const getFavicons = () => ([
  {
    rel: 'icon',
    sizes: '32x32',
    href: 'https://vkplay.ru/favicon.ico',
  },
  {
    rel: 'icon',
    type: 'image/svg+xml',
    href: 'https://vkplay.ru/hotbox/favicon/favicon.svg',
  },
  {
    rel: 'apple-touch-icon',
    href: 'https://vkplay.ru/hotbox/favicon/android-chrome-180x180.png',
  },
]);

export const getAlternateUrls = () => {
  const search = query_string(window.location.search);
  const result = [];

  delete search.lang;

  result.push({ rel: 'alternate', href: window.location.origin + window.location.pathname, hreflang: 'x-default' });
  result.push({ rel: 'alternate', href: window.location.origin + window.location.pathname, hreflang: 'ru' });

  return result;
};

export const getCanonical = () => {
  const search = query_string(window.location.search);
  const { lang } = search;

  return window.location.origin + window.location.pathname + (lang && lang !== 'ru_RU' ? `?lang=${lang}` : '');
};

export const isRtl = () => document.dir === 'rtl';
